<template>
  <div class="filters-universal">
    <div
      v-for="(filterGroup, groupName) in filterOptions"
      :key="groupName"
      :class="['filter-group', groupName]"
    >
      <label>{{ singularize(groupName) }}</label>
      <div class="custom-dropdown">
          <div class="dropdown-options">
          <div
            v-for="option in filterGroup"
            :key="option"
            class="dropdown-option"
            :class="{ selected: isSelected(groupName, option) }"
            @click="selectOption(groupName, option)"
          >
            {{ option }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <span class="buttons-inline"> <div class="filtered-count">
    <div style="text-align: center;" :class="{ alert: filterCount === 0 }">{{ filterCount }} watch{{ filterCount === 1 ? '' : 'es' }} match{{ filterCount === 1 ? 'es' : '' }} your criteria.</div>
      <!-- <div style="text-align: center; width: 100%;" v-else-if="this.showFilters" :class="{ alert: filteredWatches.length === 0 }">{{ filteredWatches.length }} watches available</div> -->
    </div>
    <button class="filter-reset" @click="resetFilters">Reset</button>
    <button class="filter-reset" @click="closeAndToggleFilters">Close</button>
  </span>
</template>

<script>
export default {
  name: "FiltersComponent",
  props: {
    filterOptions: {
      type: Object,
      required: true,
    },
    filterCount: {
      type: Number,
      default: 0, // Set a default value if needed
    },
  },
  emits: ['filters-active', 'filter-changed', 'close-filters'], // declare emitted events
  data() {
    return {
      selectedFilters: {
        locations: [],
        models: [],
        movements: [],
        materials: [],
        //Jewellery
        types: [],
        metals: [],
        stones: [],
      },
      // isOpen: {},
    };
  },
  computed: {
    filtersActive() {
      return Object.values(this.selectedFilters).some(group => group.length > 0);
    },
  },
  methods: {
    emitFilters() {
      this.$emit("filter-changed", this.selectedFilters);
    },
    resetFilters() {
      this.selectedFilters = {
        locations: [],
        models: [],
        movements: [],
        materials: [],
        //Jewellery
        types: [],
        metals: [],
        stones: [],
      };
      this.emitFilters(); // Emit reset event
    },
    isSelected(groupName, option) {
      return this.selectedFilters[groupName].includes(option);
    },

    selectOption(groupName, option) {
      const isSelected = this.isSelected(groupName, option);

      if (isSelected) {
        // Deselect the option
        this.selectedFilters[groupName] = this.selectedFilters[groupName].filter(item => item !== option);
      } else {
        // Select the option
        this.selectedFilters[groupName].push(option);
      }

      this.emitFilters(); // Emit the updated filters
    },
    updateFiltersActive() {
      this.$emit('filters-active', this.filtersActive);
    },
    closeAndToggleFilters() {
      // Emit an event to the parent component
      this.$emit('close-filters');
    },
    singularize(word) {
      // Simple singularization logic (remove 's' if it ends with 's')
      return word.endsWith('s') ? word.slice(0, -1) : word;
    }
  },
  watch: {
    filtersActive: {
      handler(newFiltersActive) {
        this.updateFiltersActive();
      },
      immediate: true,
    },
  },
};
</script>
